import gun2 from '../assets/images/gun2.jpeg'
import githubIcon from '../assets/images/icons/github_PNG23.png';
import linkedinIcon from '../assets/images/icons/linkedin.png';
import bandcampIcon from '../assets/images/icons/bandcamp.png';

const Contact = () => {
    return (
        <div className="relative container w-full mx-auto min-h-screen flex items-center justify-center">
            <div className='absolute inset-0 w-full h-full object-cover'>
                <img className="absolute inset-0 w-full h-full object-cover" src={gun2} alt="Fintan w/ gun" />
                <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center space-y-8 p-4">
                    <h1 className="text-4xl sm:text-6xl pt-3 text-center">Get In Touch:</h1>
                    <h2 className="text-2xl sm:text-4xl pt-3 text-center">
                        <a href="mailto:fintanggallagher@gmail.com" className="hover:underline">
                            fintanggallagher@gmail.com
                        </a>
                    </h2>
                    <a href="https://github.com/fintan-gallagher" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center rounded-lg shadow custom-hover-bg dark:border-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700 p-4">
                        <img src={githubIcon} className="object-contain h-24 w-24 rounded-t-lg" alt="GitHub" />
                    </a>
                    <a href="https://www.linkedin.com/in/fintan-gallagher-534761333/" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center rounded-lg shadow custom-hover-bg dark:border-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700 p-4">
                        <img src={linkedinIcon} className="object-contain h-24 w-24 rounded-t-lg" alt="LinkedIn" />
                    </a>
                    <a href="https://regretwillcome.bandcamp.com" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center rounded-lg shadow custom-hover-bg dark:border-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700 p-4">
                        <img src={bandcampIcon} className="object-contain h-24 w-24 rounded-t-lg" alt="Bandcamp" />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Contact;